import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

const DebouncedInput = ({ defaultValue, onChange, realTimeData, value, ...props }) => {
  const [internalValue, setInternalValue] = useState(value || defaultValue || '');

  useEffect(() => {
    // Keep one source of truth
    setInternalValue(value);
  }, [value]);

  const update = useMemo(
    () =>
      debounce((event) => {
        onChange(event);
      }, 250),
    [onChange]
  );

  const handleChange = useCallback(
    (event) => {
      const { target } = event;
      setInternalValue(target.value);
      if (realTimeData) {
        realTimeData({ target });
      }
      update({ target });
    },
    [realTimeData, update]
  );

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <input {...props} value={internalValue} onChange={handleChange} />;
};

DebouncedInput.propTypes = {
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  onChange: PropTypes.func.isRequired,
  realTimeData: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired
};

DebouncedInput.defaultProps = {
  defaultValue: '',
  realTimeData: null
};

export default DebouncedInput;
